import VnrLink from '@components/VnrLink';
import React from 'react';

import PostItem from '../PostItem';
import LargePostItem from '../PostItem/LargePostItem';
import TitleSection from '../TitleSection';
import styles from './PostGroup.module.scss';

const PostGroup = ({ title, posts, isMore, linkLoadMore, isShowExcerptFirstPost }) => {
  if (!posts || posts.length === 0) {
    return null;
  }
  const lastedPost = posts[0];
  const previousPosts = posts.slice(1, 5);
  return (
    <div className={styles.vnrPostGroup}>
      <TitleSection title={title} isMore={linkLoadMore ? isMore : false} link={linkLoadMore} />
      <LargePostItem post={lastedPost} isShowExcerptFirstPost={isShowExcerptFirstPost} />
      {previousPosts.map(post => {
        return <PostItem key={post.id} post={post} />
      })}
      <div className={styles.readMorePostGroup}>
        <VnrLink
          to={linkLoadMore}
          className={styles.readMoreText}
        >
          &#187; Xem tất cả
        </VnrLink>
      </div>
    </div>
  )
}
export default PostGroup;
